import { CSSProperties } from 'react';
import { statusColors } from '../constants';
import { InvoiceStatus } from '../enums/invoiceStatus';
import { PaymentStatus } from '../enums/paymentStatus';
import { TalentStatus } from '../enums/talentStatus';
import { ManagerStatus } from '../enums/managerStatus';
import { CompanyStatus } from '../enums/companyStatus';
import { ReportStatus } from '../enums/reportStatus';

export const getRoundStatusStyle = (
  status:
    | InvoiceStatus
    | TalentStatus
    | PaymentStatus
    | ManagerStatus
    | CompanyStatus
    | ReportStatus
): CSSProperties => {
  return {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: statusColors[status],
    padding: '4px 8px',
    borderRadius: '20px',
    color: '#4A4A4A'
  };
};
